import SettingsModel from "../models/settings.model";
import { SettingsType } from "../types/settings";
import { useReducerAsState } from "./useReducerAsState"

interface State {
    loading : boolean;
    error: string;
    settings : SettingsType | null;
}

const useSettings = () => {
    const [state, setState] = useReducerAsState<State>({
        loading : false,
        error: "",
        settings: null,
    })

    const { loading, settings, error } = state

    const fetchSettings = async () => {
        setState({loading: true, error: ""})
        const response = await SettingsModel.find()
        if(response.error){
            setState({loading: false, error: response.error})
            return
        }

        setState({loading: false, error: "", settings: response.settings?.data[0]})
    }

    const saveSettings = async (item: SettingsType): Promise<boolean> => {
        setState({loading: true, error: ""})
        const response = await SettingsModel.save(item)
        if(response.error){
            setState({loading: false, error: response.error})
            return false
        }

        setState({loading: false, error: ""})
        return true
    }

    return {
        loading,
        error,
        settings,
        fetchSettings,
        saveSettings
    }
}

export default useSettings